import { PutAdresse } from './put-adresse';

export class PostContactAdresse {
  public description?: string;
  public type?: string;
  public adresse: PutAdresse;
}
